import React, { Component, Fragment } from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import {
  MDBBtn,
  MDBBtnGroup,
  MDBCol,
  MDBContainer,
  MDBRow,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from 'mdb-react-ui-kit'
import { toast } from 'react-toastify'
import { format, startOfMonth } from 'date-fns'
import { UIDatePickerInput } from '../../components/forms/form-fields'
import LoadingSpinner from '../../components/shared/LoadingSpinner.component'
import PromotionCodeRedemptionService from '../../shared/services/PromotionCodeRedemption.service'

const VIEWS = [
  { key: 'summary', label: 'Summary' },
  { key: 'detail', label: 'Detail' },
]

const toYmd = date => format(date, 'yyyy-MM-dd')

class PromoCodeRedemptions extends Component {
  constructor(props) {
    super(props)

    this.state = {
      view: 'summary',
      dateFrom: startOfMonth(new Date()),
      dateTo: new Date(),
      report: null,
      loading: false,
      exporting: false,
    }
  }

  componentDidMount() {
    this._fetchReport()
  }

  _getRange = () => ({ start: toYmd(this.state.dateFrom), end: toYmd(this.state.dateTo) })

  _fetchReport = async () => {
    const { dateFrom, dateTo, view } = this.state
    if (!dateFrom || !dateTo || dateFrom > dateTo) return

    // Ignore responses that were superseded by a newer filter change.
    const requestId = (this._requestId = (this._requestId || 0) + 1)
    this.setState({ loading: true })

    let report = null
    try {
      report = await PromotionCodeRedemptionService.report(view, { query: this._getRange() })
    } catch (ex) {
      if (requestId === this._requestId) toast.error('Failed to fetch the Promo Code Redemptions report.')
    }

    if (requestId === this._requestId) this.setState({ report, loading: false })
  }

  _exportReport = async () => {
    this.setState({ exporting: true })

    try {
      const result = await PromotionCodeRedemptionService.exportReport({ view: this.state.view, ...this._getRange() })
      if (result?.url) window.open(result.url)
    } catch (ex) {
      toast.error(`${ex.message || 'Failed to export the Promo Code Redemptions report.'}`)
    }

    this.setState({ exporting: false })
  }

  _setDate = (key, value) => this.setState({ [key]: value || null }, this._fetchReport)

  _setView = view => this.state.view !== view && this.setState({ view, report: null }, this._fetchReport)

  _renderTable = () => {
    const { report, loading } = this.state

    if (loading) return <LoadingSpinner size='md' isActive={true} />

    if (!report?.total) return <p className='text-center text-muted py-4 mb-0'>No redemptions found</p>

    return (
      <MDBTable striped bordered small responsive>
        <MDBTableHead>
          <tr>
            {report.columns.map(c => (
              <th key={c.field}>{c.label}</th>
            ))}
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {report.rows.map((row, idx) => (
            <tr key={idx}>
              {report.columns.map(c => (
                <td key={c.field}>{row[c.field]}</td>
              ))}
            </tr>
          ))}
        </MDBTableBody>
      </MDBTable>
    )
  }

  render() {
    toast.configure()

    const { view, dateFrom, dateTo, report, loading, exporting } = this.state,
      invalidRange = !dateFrom || !dateTo || dateFrom > dateTo

    return (
      <Fragment>
        <DashboardLayout>
          <main className='mainSection pb-5'>
            <MDBContainer fluid className='mt-5'>
              <h2>Promo Code Redemptions</h2>
              <hr />
              <MDBRow className='align-items-end mb-3'>
                <MDBCol size='12' sm='6' lg='3' className='mb-3'>
                  <UIDatePickerInput
                    name='date_from'
                    id='date_from'
                    label='From'
                    dateFormat='MM/dd/yyyy'
                    selected={dateFrom}
                    maxDate={dateTo || undefined}
                    onChange={evt => this._setDate('dateFrom', evt.target.value)}
                  />
                </MDBCol>
                <MDBCol size='12' sm='6' lg='3' className='mb-3'>
                  <UIDatePickerInput
                    name='date_to'
                    id='date_to'
                    label='To'
                    dateFormat='MM/dd/yyyy'
                    selected={dateTo}
                    minDate={dateFrom || undefined}
                    onChange={evt => this._setDate('dateTo', evt.target.value)}
                  />
                </MDBCol>
                <MDBCol size='12' lg='6' className='mb-3 d-flex flex-wrap justify-content-lg-end gap-2'>
                  <MDBBtnGroup>
                    {VIEWS.map(v => (
                      <MDBBtn
                        key={v.key}
                        color='primary'
                        outline={view !== v.key}
                        onClick={() => this._setView(v.key)}
                        aria-pressed={view === v.key}
                      >
                        {v.label}
                      </MDBBtn>
                    ))}
                  </MDBBtnGroup>
                  <MDBBtn
                    color='success'
                    disabled={loading || exporting || invalidRange || !report?.total}
                    onClick={this._exportReport}
                  >
                    {exporting ? <i className='fa fa-spin fa-spinner' /> : 'Export'}
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
              {invalidRange ? (
                <p className='text-center text-danger py-4 mb-0'>Select a valid date range.</p>
              ) : (
                this._renderTable()
              )}
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default PromoCodeRedemptions
